import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'

import { CrudStore } from 'core/types/crudStore'

import type { AcknowledgmentCommitmentItem } from '../model/types'

import { recordAcknowledgmentCall } from './recordAcknowledgmentCall'

export const upsertPbmManagerConfirmation = async (
  item: AcknowledgmentCommitmentItem,
  debugSource?: string | null
) => {
  const crudPBMToManagers = CrudStore.get(CrudStoreItemPartner360.PBMManagers)
  const isNew = !item.EntryId950

  const pbmToManagerEntry = isNew
    ? {
        EntryId: 0,
        PBMConfirmed: 1,
        ProgramType: item.ProgramType,
        PBMEmail: item.PBMEmail,
        ManagerEmail: item.SignerEmail ?? '',
        ManagerFirstName: item.SignerFirstName ?? '',
        ManagerLastName: item.SignerLastName ?? '',
      }
    : {
        EntryId: item.EntryId950,
        PBMConfirmed: 1,
      }

  const method = isNew ? crudPBMToManagers.create : crudPBMToManagers.update

  await recordAcknowledgmentCall(
    {
      name: 'pbm-managers-950',
      method: isNew ? 'CREATE' : 'UPDATE',
      url: `CrudStore · PBMManagers · ${isNew ? 'create' : 'update'}`,
      body: pbmToManagerEntry,
      target: 'useAcknowledgmentActions · reload()',
      source: debugSource,
    },
    () => method({ formId: '950', code: 'pbm-managers-950' }, [pbmToManagerEntry])
  )
}
